'use es6';

export const INITIAL_OPT_IN_COOKIE = '__hs_initial_opt_in';
export const OPT_OUT_COOKIE = '__hs_opt_out';
export const SESSION_COOKIE = '__hssc';
export const SESSION_RESTART_COOKIE = '__hssrc';
export const DO_NOT_TRACK = '__hs_do_not_track';
export const UTK_COOKIE = '__hstc';
export const UTK_LEGACY_COOKIE = 'hubspotutk';
export const MESSAGESUTK = 'messagesUtk';
export const CATEGORY_PREFERENCES_COOKIE = '__hs_cookie_cat_pref';
export const CATEGORY_PREFERENCES_COOKIE_EXPIRATION = 180;
export const OPT_OUT_COOKIE_EXPIRATION = 180;
export const INITIAL_OPT_IN_COOKIE_EXPIRATION = 7;
export const FACEBOOK_PIXEL_COOKIE = '_fbp';
export const NOTIFY_BANNER_DISMISS_COOKIE = '__hs_notify_banner_dismiss';
export const NOTIFY_BANNER_DISMISS_COOKIE_EXPIRATION = 180;
export default [CATEGORY_PREFERENCES_COOKIE, INITIAL_OPT_IN_COOKIE, OPT_OUT_COOKIE, SESSION_COOKIE, SESSION_RESTART_COOKIE, DO_NOT_TRACK, UTK_COOKIE, UTK_LEGACY_COOKIE, MESSAGESUTK, NOTIFY_BANNER_DISMISS_COOKIE];